<template>
	<img :src="dynaSrc(src)"  />
</template>

<script>
	import { mapState } from 'vuex'
	export default{
		props:{
			src:{
				type:String,
				default:''
			}
		},
		computed:{
			...mapState([
				'vuex_windowWidth'
			]),
			dynaSrc(){
				return val => {
					const findInd = val.lastIndexOf(".")
					let str = val.slice(findInd-2,findInd)
					if(this.vuex_windowWidth < 768){
						if(str == 'pc'){
							return val.replace(/(.*)pc/g,'$1mb')
						}else{
							return val
						}
					}else{
						if(str == 'mb'){
							return val.replace(/(.*)mb/g,'$1pc')
						}else{
							return val
						}
					}
				}
			}
		}
	}
</script>

<style>
</style>
